export default function CalendarIcon(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 22 22" {...props}>
      <g transform="translate(-27 -34)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path
          stroke="currentColor"
          strokeWidth={2}
          d="M28 40.333a2.667 2.667 0 012.667-2.666h14a2.667 2.667 0 012.666 2.666v11.334a2.667 2.667 0 01-2.666 2.666h-14A2.666 2.666 0 0128 51.667V40.333zM32.333 35v4.667M43 35v4.667M32 43h11.333"
        />
      </g>
    </svg>
  );
}
